import React from 'react';
import { Row, Col, Navbar, FormGroup, FormControl, Alert, Modal, Button } from 'react-bootstrap';

import SearchEpcList2Container from '../containers/SearchEpcList2Container.jsx';
import SearchMRecordListContainer from '../containers/SearchMRecordListContainer.jsx';
import MaintenanceSearchRecordContainer from '../containers/MaintenanceSearchRecordContainer.jsx';
import RfidSettingContainer from '../containers/RfidSettingContainer.jsx';

export default class MaintenanceSearchComponent extends React.Component {

	componentDidMount() {
		this.props.cleanAlert();
		this.props.cleanSearchResult();
	}

	componentWillUnmount() {
		this.props.cleanAlert();
		this.props.cleanSearchResult();
	}

	handleSearchEpc(searchEpcInput) {
		this.props.searchEpc(searchEpcInput);
	}

	handleSearchLabelId(searchLabelIdInput) {
		this.props.searchLabelId(searchLabelIdInput);
	}

	readRfidChips() {
		let reader = {
			name: localStorage.getItem('rfid.name'),
			hostname: localStorage.getItem('rfid.hostname'),
			port: localStorage.getItem('rfid.port'),
			sensitivity: localStorage.getItem('rfid.sensitivity'),
		}
		this.props.readRfidChips(reader);
	}

	showRfidConfig() {
        this.props.cleanRfidChips();
        this.props.showRfidConfig();
	}

	render() {

		let alertDiv = null;
		if (this.props.alertStyle || this.props.alertMessage) {
			alertDiv = (
				<Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
					{this.props.alertMessage}
				</Alert>
			);
		}

		// 是否為讀取中
		let disableReadRfid = false;
		let readRfidText = "EPC 晶片讀取";
		if (this.props.isLoadingChipEpcs) {
			disableReadRfid = true;
			readRfidText = "EPC 晶片讀取中"
		}

		return (
			<div>
				<h4>清洗維修紀錄查詢</h4>
				<Row>
					<Col style={{ marginTop: 10 }}>
						{alertDiv}
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={6} md={4} lg={4}>
						<div style={{ textAlign: 'left', marginLeft: -15 }}>
							<Navbar.Form>
								<FormGroup>
									<FormControl type="text" placeholder='EPC 搜尋' inputRef={ref => { this.searchEpcInput = ref; }} tabIndex="10" size="24"
										onKeyDown={(event) => {
											// keyCode = 13 => eneter 鍵
											if (event.keyCode === 13) {
												this.handleSearchEpc(this.searchEpcInput.value);
											}
										}} />
								</FormGroup>
								<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
									this.handleSearchEpc(this.searchEpcInput.value);
								}} tabIndex="11" />
							</Navbar.Form>
							<Navbar.Form>
								<FormGroup>
									<FormControl type="text" placeholder='洗標條碼 搜尋' inputRef={ref => { this.searchLabelIdInput = ref; }} tabIndex="20" size="24"
										onKeyDown={(event) => {
											// keyCode = 13 => eneter 鍵
											if (event.keyCode === 13) {
												this.handleSearchLabelId(this.searchLabelIdInput.value);
											}
										}} />
								</FormGroup>
								<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
									this.handleSearchLabelId(this.searchLabelIdInput.value);
								}} tabIndex="21" />
							</Navbar.Form>
						</div>
					</Col>
					<Col xs={12} sm={6} md={8} lg={8}>
						<div style={{ textAlign: 'left', marginLeft: -15, marginTop: 7 }}>
							<Button bsStyle="info" disabled={disableReadRfid}
								onClick={(event) => { this.readRfidChips() }}>
								{readRfidText}
							</Button>
							&nbsp;&nbsp;
							<Button title="RFID 讀取機設定"
								onClick={(event) => { this.showRfidConfig() }}>
								<img src="gear.svg" height="20" width="20" alt="" />
							</Button>
						</div>
					</Col>
				</Row>
				<Row style={{ paddingTop: 5 }}>
					<Col xs={12}>
						<h4><b>出貨記錄:</b></h4>
						<SearchEpcList2Container />
						<span style={{color: 'blue'}}>點選列表 <span className="glyphicon glyphicon-list-alt" /> 顯示該筆出貨衣褲的「清洗維修資料」</span>
					</Col>
				</Row>
				<hr />
				<Row style={{ paddingTop: 5 }}>
					<Col xs={12}>
						<h4><b>清洗維修記錄:</b></h4>
						<SearchMRecordListContainer />
						<span style={{color: 'blue'}}>點選列表 <span className="glyphicon glyphicon-list-alt" /> 顯示該筆記錄的「清洗維修明細」</span>
					</Col>
				</Row>

				<Modal bsSize="lg" show={this.props.showModal} onHide={this.props.closeModal} backdrop="static">
					<Modal.Header closeButton />
					<Modal.Body>
						<MaintenanceSearchRecordContainer />
					</Modal.Body>
				</Modal>

                <Modal show={this.props.view.get('showRfidConfig')} onHide={this.props.hideRfidConfig} backdrop="static">
                    <Modal.Header closeButton >
                        <Modal.Title id="rfid-config">選取/更改 RFID 讀取機</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RfidSettingContainer />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={(event) => { this.props.hideRfidConfig() }} >離開</Button>
                    </Modal.Footer>
                </Modal>

			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceSearchComponent.jsx